<form class="field-dialog__content__scroll p-24" fxLayout="column" name="form" fusePerfectScrollbar>
  <div fxLayout="column" *ngIf="!isAllDatesAsNull">
    <div fxLayout="row" fxLayout.xs="row wrap" fxLayoutAlign="start center" Flex>
      <mat-form-field appearance="legacy" fxFlex="40" class="pr-4">
        <mat-label>{{ 'MAINTENANCES.TABS.DEADLINES.RESPONSE_DEADLINE' | translate }}</mat-label>
        <input
          matInput
          [value]="firstVisitDeadlineAt | translate"
          placeholder="{{ 'MAINTENANCES.TABS.DEADLINES.RESPONSE_DEADLINE' | translate }}"
          readonly
        />
      </mat-form-field>

      <mat-form-field appearance="legacy" fxFlex="40" class="pr-4">
        <mat-label>{{ 'MAINTENANCES.TABS.DEADLINES.RESPONSE_AT' | translate }}</mat-label>
        <input
          matInput
          [value]="firstVisitStartedAt | translate"
          placeholder="{{ 'MAINTENANCES.TABS.DEADLINES.RESPONSE_AT' | translate }}"
          readonly
        />
      </mat-form-field>

      <mat-form-field appearance="legacy" fxFlex="30" class="pr-4">
        <mat-label>{{ 'MAINTENANCES.TABS.DEADLINES.SITUATION' | translate }}</mat-label>
        <input
          matInput
          [value]="firstVisitDeadLineMessage | translate"
          placeholder="{{ 'MAINTENANCES.TABS.DEADLINES.SITUATION' | translate }}"
          readonly
          [style.color]="colorMessageFirstVisitDeadline"
        />
      </mat-form-field>
    </div>

    <div fxLayout="row" fxLayout.xs="row wrap" fxLayoutAlign="start center" Flex>
      <mat-form-field appearance="legacy" fxFlex="35" class="pr-4">
        <mat-label>{{ 'MAINTENANCES.TABS.DEADLINES.COMPLETE_DEADLINE' | translate }}</mat-label>
        <input
          matInput
          [value]="deadlineAt | translate"
          placeholder="{{ 'MAINTENANCES.TABS.DEADLINES.COMPLETE_DEADLINE' | translate }}"
          readonly
        />
      </mat-form-field>

      <mat-form-field appearance="legacy" fxFlex="35" class="pr-4">
        <mat-label>{{ 'MAINTENANCES.TABS.DEADLINES.CLOSED_AT' | translate }}</mat-label>
        <input
          matInput
          [value]="closedAt | translate"
          placeholder="{{ 'MAINTENANCES.TABS.DEADLINES.CLOSED_AT' | translate }}"
          readonly
        />
      </mat-form-field>

      <mat-form-field appearance="legacy" fxFlex="30" class="pr-4">
        <mat-label>{{ 'MAINTENANCES.TABS.DEADLINES.SITUATION' | translate }}</mat-label>
        <input
          matInput
          [value]="closedDeadlineMessage | translate"
          placeholder="{{ 'MAINTENANCES.TABS.DEADLINES.SITUATION' | translate }}"
          readonly
          [style.color]="colorMessageClosedDeadline"
        />
      </mat-form-field>
    </div>
  </div>

  <div fxLayout="column" fxLayoutAlign="center center" *ngIf="isAllDatesAsNull">
    <p fxFlex="100" fxLayout="row">
      <mat-icon class="s-32">event</mat-icon>
    </p>
    <span class="h3">
      {{ 'MAINTENANCES.TABS.DEADLINES.WITHOUT_DEADLINES' | translate }}
    </span>
  </div>
</form>
